import { FilesUploader } from "components";
import { MediaDirectoryKeys } from "constants/enums";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField, MediaFilePicker } from "ui";

import { NotificationFormValues } from "../NotificationForm.types";

export const ImageField = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<NotificationFormValues>();

  return (
    <Controller
      control={control}
      name={"image"}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <FormField
          label={t("Notification image")}
          errorMessage={error?.message}
        >
          <FilesUploader
            onSuccessUploading={onChange}
            uploadDirectoryKey={MediaDirectoryKeys.ProductVariant}
          >
            {(uploaderProps) => (
              <MediaFilePicker
                {...uploaderProps}
                value={value}
                label={"210:130"}
                customSize={{ width: 210, height: 130 }}
                customMaxFileSizeInMB={1}
                onDeleteMediaFile={() => onChange(null)}
              />
            )}
          </FilesUploader>
        </FormField>
      )}
    />
  );
};
